import SeoHead from '../../components/SeoHead';
import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import React from 'react';
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import Link from 'next/link';
import SubBanner from '../../components/SubBanner';
import AllConsultants from '../../components/AllConsultants';
import Header from '../../components/MainHeader';
import SimplePage from '../../components/SimplePage';

export default function MeetTheTeam({
    global,
    all_consultant
}) {
    return (
        <>
            <SeoHead
                // site_name={`Driving Force`}
                page_name={`Meet the team | Gap Personnel`}
                // description={`Meet the team at Driving Force. We are all passionate about what we do and our aim is to deliver a service that gives you the results you need.`}
                canonical_link={`/meet-the-team/`}
            />
            <Header />
            <SubBanner
                global={global}
                pathPrefix={`meet_the_team_page.sub_banner`}
                customClass={`mb-5 primary-banner meet-the-team`}
                buttonTitle={`Employers`}
                buttonLink={`/who-we-are/`}
                heading={`Meet the team`}
                bannerImage="/site-assets/images/meet-the-team.jpg"
                bannerImageAlt="Meet the team"
            />
            <AllConsultants
                global={global}
                pathPrefix={`meet_the_team_page.all_consultants`}
                all_consultant={all_consultant}
                buttonTitle={`Profile`}
                customClass={``}
            />
            <SimplePage
                global={global}
                pathPrefix={`meet_the_team_page.simple_page`}
                customClass={``}
                content={``}
                formId={`2b1903d0-c09a-4b34-9c3b-27a7b7afb573`}
                heading={`Get in touch`}
                textCenter={true}
            />
        </>
    );
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const consultants = await Collection('consultants');
    const all_consultant = consultants.orderBy('order').getItems();
    return {
        props: {
            global,
            all_consultant
        },
    }
}